module.exports = __webpack_public_path__ + "static/img/company-component-cove-4.18750a91.jpg";